import React from 'react';
import { motion } from 'framer-motion';
import TiltedCard from './TiltedCard';
import ScrollFloat from './ScrollFloat';
import './Projects.css';

const Projects = () => {
  const projectData = [
    {
      title: 'StudyHub',
      description: 'A cloud-hosted education platform, built around automated deploys, managed authentication, and low operational overhead.',
      tags: ['Go', 'AWS', 'Cognito', 'S3', 'CI/CD', 'GitHub Actions'],
      link: 'https://www.studyhub.social'
    },
    {
      title: 'Smart Grid Energy System',
      description: 'An event-driven system that ingests, processes, and analyses energy data streaming in from distributed sources.',
      tags: ['Go', 'Event-Driven', 'Cloud-Native', 'APIs', 'Analytics']
    }
  ];

  return (
    <section id="projects" className="section snap-section projects-section-wrapper">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2 className="section-title">
            <ScrollFloat>Projects</ScrollFloat>
          </h2>
          <p className="section-subtitle">Things I have designed, shipped, and run</p>
        </motion.div>
        
        <div className="projects-grid">
          {projectData.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: false, amount: 0.3 }}
            >
              <TiltedCard>
                <div className="project-card-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-tags">
                    {project.tags.map((tag, i) => (
                      <span key={i} className="project-tag">{tag}</span>
                    ))}
                  </div>
                  {project.link && (
                    <a 
                      href={project.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      View Project →
                    </a>
                  )}
                </div>
              </TiltedCard>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
